import { findPreviousDate } from '../../../src/utils/global'

export const getters = {
    getGoldTraderPresent: state => state.goldTraderPresent,
    getGoldHistoryGraph: state => goldType => {
        if(goldType == 'trader_bar'){
            return state.goldHistoryGraph.map(item => ({
                d: item.createdAt,
                v: parseInt(item.barSellPrice),
                c: item.barPriceChange,
                t: item.createdTime
            }))
        } else {
            return state.goldHistoryGraph.map(item => ({
                d: item.createdAt,
                v: parseInt(item.ornamentSellPrice),
                c: null,
                t: item.createdTime
            }))
        }
    },
    getGoldTraderRealtimeGraph: state => state.goldTraderRealtimeGraph,
    getGoldCurrentPeriod: state => state.currentPeriod,
    getGoldPeriod: state => state.goldPeriod,
    getGoldHistoryList: state => state.goldHistoryList,

    getGoldSpotRealtimeLastPrice: state => {
        if(state.goldSpotLastPrice) return state.goldSpotLastPrice
        else if (state.goldSpotRealtimeGraph.length) return state.goldSpotRealtimeGraph[state.goldSpotRealtimeGraph.length - 1].v
    },
    getGoldSpotRealtimeGraph: state => state.goldSpotRealtimeGraph,
    getGoldSpotHistoryGraph: state => {
        return state.goldSpotHistoryGraph.map(item => ({
            d: item.t,
            v: item.c,
            t: item.t
        }))
    },
    getGoldSpotRealtimePeriod: state => state.goldSpotRealtimePeriod,
    getGoldSpotHistoryPeriod: state => state.goldSpotHistoryPeriod,
    getGoldSpotRealtimeCurrentPeriod: state => state.goldSpotRealtimeCurrentPeriod,
    getGoldSpotHistoryCurrentPeriod: state => findPreviousDate(state.goldSpotHistoryCurrentPeriod),
    getGoldSpotLastQuote: state => state.goldSpotLastQuote,
    getGoldSpotLastTrade: state => state.goldSpotLastTrade,
    getGoldSpotPreviousClose: state => state.goldSpotPreviousClose,
    getGoldGlobalConfig: state => state.globalConfiguration,
    // gols spot thai
    getGoldSpotThaiRealtimeGraph: state => state.goldSpotThaiRealtimeGraph,
    getGoldSpotThaiRealtimeCurrentPeriod: state => state.goldSpotThaiRealtimeCurrentPeriod,
    getGoldSpotThaiRealtimePeriod: state => state.goldSpotThaiRealtimePeriod,
    getGoldSpotThaiRealtimeLastPrice: state => {
        if(state.goldSpotThaiLastPrice) return state.goldSpotThaiLastPrice
        else if (state.goldSpotThaiRealtimeGraph.length) return state.goldSpotThaiRealtimeGraph[state.goldSpotThaiRealtimeGraph.length - 1].v
    },
}